'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _transitionEvents = require('domkit/transitionEvents');

var _transitionEvents2 = _interopRequireDefault(_transitionEvents);

var _appendVendorPrefix = require('domkit/appendVendorPrefix');

var _appendVendorPrefix2 = _interopRequireDefault(_appendVendorPrefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

module.exports = function (animation) {
  var _desc, _value, _class, _class2, _temp2;

  return _class = (_temp2 = _class2 = function (_React$Component) {
    (0, _inherits3.default)(Modal, _React$Component);

    function Modal() {
      var _ref;

      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, Modal);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        willHidden: false,
        hidden: true
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Modal, [{
      key: 'hasHidden',
      value: function hasHidden() {
        return this.state.hidden;
      }
    }, {
      key: 'addTransitionListener',
      value: function addTransitionListener(node, handle) {
        if (node) {
          var endListener = function endListener(e) {
            if (e && e.target !== node) {
              return;
            }
            _transitionEvents2.default.removeEndEventListener(node, endListener);
            handle();
          };
          _transitionEvents2.default.addEndEventListener(node, endListener);
        }
      }
    }, {
      key: 'handleBackdropClick',
      value: function handleBackdropClick() {
        if (this.props.closeOnClick) {
          this.hide('backdrop');
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var hidden = this.hasHidden();
        if (hidden) return null;

        var willHidden = this.state.willHidden;
        var animation = this.props.animation;
        var modalStyle = animation.getModalStyle(willHidden);
        var backdropStyle = animation.getBackdropStyle(willHidden);
        var contentStyle = animation.getContentStyle(willHidden);
        var ref = animation.getRef(willHidden);
        var sharp = animation.getSharp && animation.getSharp(willHidden);

        // Apply custom style properties
        if (this.props.modalStyle) {
          var prefixedModalStyle = (0, _appendVendorPrefix2.default)(this.props.modalStyle);
          for (var style in prefixedModalStyle) {
            modalStyle[style] = prefixedModalStyle[style];
          }
        }

        if (this.props.backdropStyle) {
          var prefixedBackdropStyle = (0, _appendVendorPrefix2.default)(this.props.backdropStyle);
          for (var style in prefixedBackdropStyle) {
            backdropStyle[style] = prefixedBackdropStyle[style];
          }
        }

        if (this.props.contentStyle) {
          var prefixedContentStyle = (0, _appendVendorPrefix2.default)(this.props.contentStyle);
          for (var style in prefixedContentStyle) {
            contentStyle[style] = prefixedContentStyle[style];
          }
        }

        var backdrop = this.props.backdrop ? _react2.default.createElement('div', {
          style: backdropStyle,
          onClick: this.props.closeOnClick ? this.handleBackdropClick : null
        }) : undefined;

        if (willHidden) {
          var node = this.refs[ref];
          this.addTransitionListener(node, this.leave);
        }

        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'div',
            { ref: 'modal', style: modalStyle, className: this.props.className },
            sharp,
            _react2.default.createElement(
              'div',
              { ref: 'content', tabIndex: '-1', style: contentStyle },
              this.props.children
            )
          ),
          backdrop
        );
      }
    }, {
      key: 'leave',
      value: function leave() {
        this.setState({
          hidden: true
        });
        this.props.onHide(this.state.hideSource);
      }
    }, {
      key: 'enter',
      value: function enter() {
        this.props.onShow();
      }
    }, {
      key: 'show',
      value: function show() {
        if (!this.hasHidden()) return;

        this.setState({
          willHidden: false,
          hidden: false
        });

        setTimeout(function () {
          var ref = this.props.animation.getRef();
          var node = this.refs[ref];
          this.addTransitionListener(node, this.enter);
        }.bind(this), 0);
      }
    }, {
      key: 'hide',
      value: function hide(source) {
        if (this.hasHidden()) return;

        if (!source) {
          source = 'hide';
        }

        this.setState({
          hideSource: source,
          willHidden: true
        });
      }
    }, {
      key: 'toggle',
      value: function toggle() {
        if (this.hasHidden()) this.show();else this.hide('toggle');
      }
    }, {
      key: 'listenKeyboard',
      value: function listenKeyboard(event) {
        typeof this.props.keyboard == 'function' ? this.props.keyboard(event) : this.closeOnEsc(event);
      }
    }, {
      key: 'closeOnEsc',
      value: function closeOnEsc(event) {
        if (this.props.keyboard && (event.key === 'Escape' || event.keyCode === 27)) {
          this.hide('keyboard');
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('keydown', this.listenKeyboard, true);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('keydown', this.listenKeyboard, true);
      }
    }]);
    return Modal;
  }(_react2.default.Component), _class2.propTypes = {
    className: _propTypes2.default.string,
    // Close the modal when esc is pressed? Defaults to true.
    keyboard: _propTypes2.default.bool,
    onShow: _propTypes2.default.func,
    onHide: _propTypes2.default.func,
    animation: _propTypes2.default.object,
    backdrop: _propTypes2.default.bool,
    closeOnClick: _propTypes2.default.bool,
    modalStyle: _propTypes2.default.object,
    backdropStyle: _propTypes2.default.object,
    contentStyle: _propTypes2.default.object
  }, _class2.defaultProps = {
    className: '',
    onShow: function onShow() {},
    onHide: function onHide() {},
    animation: animation,
    keyboard: true,
    backdrop: true,
    closeOnClick: true,
    modalStyle: {},
    backdropStyle: {},
    contentStyle: {}
  }, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'hasHidden', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'hasHidden'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addTransitionListener', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'addTransitionListener'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleBackdropClick', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleBackdropClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'leave', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'leave'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'enter', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'enter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'show', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'show'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hide', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'hide'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggle', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'toggle'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'listenKeyboard', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'listenKeyboard'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeOnEsc', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'closeOnEsc'), _class.prototype)), _class;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/Provider/Modal/modalFactory.js
// module id = 1078
// module chunks = 83